@if (showAsDialog) {
  <div class="modal-header">
    <h4 class="modal-title">Quote</h4>
  </div>
}
@if (quote) {
  <div class="modal-body p-0 flex-fill d-flex flex-column compact-form">
    <div class="card">
      <div class="card-body p-2 pb-3">
        <div class="btn-toolbar mx-0 mb-0 mt-0">
          @if (!showAsDialog) {
            <div>
              @if (hasChanges()) {
                <button class="btn btn-sm btn-primary me-2" (click)="save()">Save</button>
              }
              @if (hasChanges()) {
                <button class="btn btn-sm btn-success me-4" (click)="cancel()">Cancel</button>
              }
              @if (!hasChanges()) {
                <button class="btn btn-sm btn-primary me-4" (click)="close()">Close</button>
              }
              @if (!hasChanges()) {
                <button class="btn btn-sm btn-primary me-2" (click)="email()">Email Quote</button>
              }
              @if (!hasChanges()) {
                <button class="btn btn-sm btn-primary me-4" (click)="print()">Print Quote</button>
              }
              @if (!hasChanges()) {
                <button class="btn btn-sm btn-danger ms-4" (click)="delete()">Delete Quote</button>
              }
            </div>
          }
          <div class="ms-auto d-flex align-items-center">
            <ng-container>
              @if (!hasChanges()) {
                <label class="mt-2 me-2">Set Status</label>
              }
              @if (!hasChanges()) {
                <button class="btn btn-sm btn-secondary ms-2" (click)="changeStatus('pending')">Pending</button>
              }
              @if (!hasChanges()) {
                <button class="btn btn-sm btn-success ms-2" (click)="changeStatus('awarded')">Awarded</button>
              }
              @if (!hasChanges()) {
                <button class="btn btn-sm btn-danger ms-2 me-4" (click)="changeStatus('declined')">Declined</button>
              }
              <label class="mt-2 me-2">Quote Date</label>
              <dx-date-box class="me-3" [(value)]="quote.quoteDate" width="125px">
                <dx-validator validationGroup="mainValidationGroup">
                  <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
              </dx-date-box>
              <label class="mt-2 me-2">Expiration Date</label>
              <dx-date-box class="me-3" [(value)]="quote.expirationDate" width="125px">
                <dx-validator validationGroup="mainValidationGroup">
                  <dxi-validation-rule type="required"></dxi-validation-rule>
                </dx-validator>
              </dx-date-box>
            </ng-container>
            <label class="dx-box-item-content d-inline-block align-middle ms-4 me-2 mt-1">Status </label>
            <h3 style="margin-top: 0px !important">
              <strong>{{ quote.statusName }}</strong>
            </h3>
          </div>
        </div>
        <dx-form [formData]="quote" [colCount]="12" validationGroup="mainValidationGroup">
          <dxi-item itemType="group" caption="Customer" [colSpan]="3" [colCount]="1">
            <dxi-item
              dataField="customerId"
              editorType="dxSelectBox"
              [label]="{ text: 'Customer' }"
                        [editorOptions]="{
                            dataSource: customersDS,
                            valueExpr: 'id',
                            displayExpr: 'name',
                            searchMode: 'startsWith',
                            onValueChanged: customerSelectionChanged,
                            readOnly: readOnly
                        }"
              [isRequired]="true"
              >
            </dxi-item>
            <dxi-item itemType="group" [colCount]="2">
              <dxi-item dataField="quoteNumber" [label]="{ text: 'Quote #' }" [editorOptions]="{ readOnly: true }"></dxi-item>
              <dxi-item dataField="terms"></dxi-item>
            </dxi-item>
          </dxi-item>
          <dxi-item itemType="group" caption="Project" [colSpan]="2">
            <dxi-item dataField="projectName" [label]="{ text: 'Name' }">
              <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>
            <dxi-item dataField="projectLocation" [label]="{ text: 'Location' }"></dxi-item>
          </dxi-item>
          <dxi-item itemType="group" caption="Ship Address" [colSpan]="2">
            <dxi-item dataField="shipTo" editorType="dxTextArea" [label]="{ visible: false }" [editorOptions]="{ height: '115px' }"></dxi-item>
          </dxi-item>
          <dxi-item itemType="group" caption="Summary Total" [colSpan]="2">
            <dxi-item dataField="subTotal" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
            <dxi-item dataField="tax" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
            <dxi-item dataField="total" editorType="dxNumberBox" [editorOptions]="{ format: '$#,##0.00##', readOnly: true }"></dxi-item>
          </dxi-item>
        </dx-form>
      </div>
    </div>
    <div class="m-1 grid-fill" style="height: 100%">
      <dx-data-grid
        #linesGrid
        height="200"
        [dataSource]="quoteLines"
        keyExpr="id"
        [columnAutoWidth]="false"
        (onRowDblClick)="onRowDoubleClick($event)"
        (onExporting)="onExporting($event)"
        class="lines-grid"
        >
        <dxi-column dataField="lineNumber" caption="Line #" width="90" [sortIndex]="0" [sortOrder]="'asc'"></dxi-column>
        <dxi-column dataField="partNumber" caption="Part #" width="150" cellTemplate="linkTemplate"></dxi-column>
        <dxi-column dataField="description" caption="Description" width="300"></dxi-column>
        <dxi-column dataField="product.category.name" caption="Category" width="75"></dxi-column>
        <dxi-column dataField="unit" width="100"></dxi-column>
        <dxi-column dataField="quantity" caption="Qty" width="65"></dxi-column>
        <dxi-column dataField="price" caption="Price" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
        <dxi-column dataField="tax" caption="Tax" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
        <dxi-column dataField="isTaxable" caption="Taxable" width="100"></dxi-column>
        <dxi-column dataField="lineTotal" caption="Total" width="100" alignment="right" [format]="{ type: 'currency', precision: 2 }"></dxi-column>
        <dxi-column dataField="notes" caption="Notes" width="150"></dxi-column>
        <dxi-column width="100"></dxi-column>
        <div *dxTemplate="let cell of 'linkTemplate'">
          @if (cell.data.productId && cell.data.product?.material?.name !== 'DELIVERY' && !cell.data.parentLineId && !cell.data.isMisc) {
            <div class="parent-part-number">
              {{ cell.text }}
            </div>
          }
          @if (cell.data.parentLineId || cell.data.isAdditive) {
            <div class="additive-part-number">{{ cell.text }}</div>
          }
          @if (cell.data.productId && cell.data.product?.material?.name === 'DELIVERY' && !cell.data.parentLineId && !cell.data.isMisc) {
            <div class="delivery-part-number">
              {{ cell.text }}
            </div>
          }
          @if (cell.data.isMisc) {
            <div class="misc-part-number">{{ cell.text }}</div>
          }
        </div>
        <div *dxTemplate="let data of 'toolbarButtons'">
          <button
            class="btn btn-sm btn-primary"
            (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'up')"
            [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1"
            >
            <i class="fa fa-long-arrow-up" style="min-width: 15px"></i>
          </button>
          <button
            class="btn btn-sm btn-primary ms-2 me-4"
            (click)="move(linesGrid.instance.getSelectedRowsData()[0], 'down')"
            [disabled]="linesGrid.instance.getSelectedRowsData().length !== 1"
            >
            <i class="fa fa-long-arrow-down" style="min-width: 15px"></i>
          </button>
          <button class="btn btn-sm btn-primary me-2" (click)="openLine()" [hidden]="readOnly">Add Product</button>
          <button
            class="btn btn-sm btn-success me-2"
            (click)="addProductDelivery(linesGrid.instance.getSelectedRowsData())"
            [disabled]="linesGrid.instance.getSelectedRowsData().length === 0"
            [hidden]="readOnly"
            >
            Add Product Delivery
          </button>
          <button class="btn btn-sm btn-success me-2" (click)="addDelivery()" [hidden]="readOnly">Add Delivery</button>
          <button class="btn btn-sm btn-secondary me-2" (click)="addMisc()" [hidden]="readOnly">Add Misc</button>
          <button
            class="btn btn-sm btn-danger me-2"
            (click)="removeLine(linesGrid.instance.getSelectedRowsData())"
            [hidden]="readOnly"
            [disabled]="linesGrid.instance.getSelectedRowsData().length === 0"
            >
            Remove
          </button>
          <button
            class="btn btn-sm btn-warning"
            (click)="toggleIsTaxable(linesGrid.instance.getSelectedRowsData())"
            [hidden]="readOnly"
            [disabled]="linesGrid.instance.getSelectedRowsData().length === 0"
            >
            Toggle Tax
          </button>
        </div>
        <div *dxTemplate="let data of 'toolbarText'"></div>
        <dxo-selection mode="multiple"></dxo-selection>
        <dxo-editing [mode]="'cell'" [allowUpdating]="!readOnly"></dxo-editing>
        <dxo-export [enabled]="true"></dxo-export>
        <dxo-state-storing [enabled]="true" [storageKey]="'quote-detail-grid'"></dxo-state-storing>
      </dx-data-grid>
    </div>
    <div class="card">
      <div class="card-body">
        <dx-form [formData]="quote" [colCount]="2">
          <dxi-item itemType="group">
            <dxi-item dataField="notes" editorType="dxTextArea" [label]="{ text: 'Notes' }" [editorOptions]="{ height: 100 }"> </dxi-item>
          </dxi-item>
        </dx-form>
      </div>
    </div>
  </div>
}
@if (showAsDialog) {
  <div class="modal-footer">
    <button class="btn btn-success" (click)="dialogSave()">Save</button>
    <button class="btn btn-light" (click)="dialogCancel()">Cancel</button>
  </div>
}
